import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getForTreeSelect: async (parameter) => {
		return await commonApi().get('/v1/icsProducts/getForTreeSelect', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getNotificationICSProducts: async (parameter) => {
		return await commonApi().get('/v1/icsProducts/getNotificationICSProducts',
				{
					params: parameter,
					paramsSerializer: (params) => {
						return qs.stringify(params);
					}
				})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getICSProductInterpreted: async (parameter) => {
		return await commonApi().get('/v1/icsProducts/getICSProductInterpreted',
				{
					params: parameter,
					paramsSerializer: (params) => {
						return qs.stringify(params);
					}
				})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}